import { ToastMessage } from "primereact/toast"
import { useContext } from "react"
import { ToastContext } from "src/app/toast-context"

export function useToast(): (message: ToastMessage | ToastMessage[]) => void {
  const toast = useContext(ToastContext)
  return (message) => toast?.current?.show(message)
}